import clsx from "clsx";
import { Dropdown } from "bootstrap";
import { useEffect, useRef, useState } from "react";

export const PlayerButton = (props: {
    disabled?: boolean;
    character: string | null;
    isBanned: boolean;
    isLeaver: boolean;
    isConnected: boolean;
    isCompleted: boolean;
    playerName: string;
    userName?: string;
    isSelected?: boolean;
    toggle?: "modal" | "dropdown";
    onClick?: () => void;
}) => {
    const {
        disabled,
        character,
        isBanned,
        isCompleted,
        isConnected,
        isLeaver,
        isSelected,
        playerName,
        toggle,
        onClick,
        userName,
    } = props;

    const btnRef = useRef<HTMLButtonElement>(null);

    const [revealed, setRevealed] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setRevealed(true);
        }, 100);
    }, []);

    // custom dropdown config so it can handle overflow hidden
    useEffect(() => {
        if (btnRef.current) {
            const dropdown = new Dropdown(btnRef.current, {
                popperConfig: {
                    strategy: "fixed",
                },
            });

            return () => {
                dropdown.hide();
                dropdown.dispose();
            };
        }
    }, [btnRef]);

    return (
        <button
            type="button"
            ref={btnRef}
            disabled={disabled}
            data-bs-toggle={toggle}
            onClick={onClick}
            style={{
                backgroundImage: `url('${character}')`,
            }}
            className={clsx(
                "players-list__btn animate",
                isSelected && "players-list__btn--selected",
                revealed ? "opacity-100" : "opacity-0",
                isBanned
                    ? "players-list__btn--banned"
                    : isLeaver
                    ? "players-list__btn--leaver"
                    : !isConnected
                    ? "players-list__btn--disconnected"
                    : isCompleted && "players-list__btn--completed",
            )}
        >
            <div className="players-list__text">{playerName}</div>

            {userName && <div className="players-list__subtext">{userName}</div>}
        </button>
    );
};
